import React, {  useMemo } from 'react';
import { DigitsBarProps } from '../types';

const DigitsBar: React.FC<DigitsBarProps> = ({
  onDigitClick,
  usedButtons,
  
  buttonStatus,
}) => {
  

  
const digits = useMemo(() => ['1', '2', '3', '4', '5', '6', '7', '8', '9'], []);

  return (
    <div className="digits-bar">
      <div className="digits-row">
        {digits.slice(0, 5).map((digit, index) => {
          return (
            <button
              key={index}
              className={`digit-button ${buttonStatus[index]}`}
              onClick={() => onDigitClick(digit, index)}
            >
              {digit}
            </button>
          );
        })}
      </div>
      <div className="digits-row">
        {digits.slice(5).map((digit, index) => {
          return (
            <button
              key={index + 5}
              className={`digit-button ${buttonStatus[index+5]}`}
              onClick={() => onDigitClick(digit, index + 5)}
            >
              {digit}
            </button>
          );
        })}
        <button
          className="digit-button delete-button"
          onClick={() => onDigitClick('delete', -1)}
        >
          <i className="fas fa-backspace"></i>
        </button>
      </div>
    </div>
  );
};

export default DigitsBar;
